import { LoadingState } from "../../../type/loading-state";

export const endGlobalLoadingDispatch = (state: LoadingState) => {
  state.globalLoading = false;
};
